<aside class="main-sidebar elevation-4 sidebar-light-info">
  <!-- Brand Logo -->
  <a [routerLink]="" class="brand-link">
    <img src="assets/img/logo.png" alt="Logo" class="brand-image img-circle elevation-3" style="opacity: .8">
    <span class="brand-text font-weight-light">{{nombreSistema}}</span>
  </a>

  <div class="sidebar">
    <!-- Sidebar Menu -->
    <nav class="mt-2">
      <ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
        <li class="nav-item has-treeview menu-open" *ngFor="let menu of sesionService.menus">
          <a [routerLink]="" class="nav-link" [ngClass]="{'active': sesionService.keySelected === menu.key}">
            <i class="nav-icon" [ngClass]="menu.icon"></i>
            <p>
              {{menu.name}}
              <i class="right fas fa-angle-left"></i>
            </p>
          </a>
          <ul class="nav nav-treeview">
            <li class="nav-item" *ngFor="let submenu of menu.subitems">
              <a class="nav-link" [routerLink]="submenu.path" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }">
                <p>{{submenu.name}}</p>
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </nav>

  </div>
</aside>